export const DEFAULT_MAP_CENTER = [
  [-37.74356694549107, 175.25735686111453],
  [-37.74356694549107, 175.25135686111453],
] as L.LatLngTuple[];
